"use client";

import { useInfiniteQuery } from "@tanstack/react-query";

import {
  getListNotificationsQueryKey,
  listNotifications,
} from "@/lib/api/generated";

import type { NotificationTab } from "../components/list/tab-items";

export const NOTIFICATIONS_KEY = getListNotificationsQueryKey();

function paramsForTab(tab: NotificationTab) {
  if (tab === "unread") {
    return { limit: 30, unread_only: true, archived: false };
  }
  if (tab === "read") {
    return { limit: 30, read_only: true, archived: false };
  }
  return { limit: 30, archived: false };
}

export function useNotifications(tab: NotificationTab = "unread") {
  const params = paramsForTab(tab);
  return useInfiniteQuery({
    queryKey: getListNotificationsQueryKey(params),
    queryFn: ({ pageParam }) =>
      listNotifications({
        cursor: pageParam as string | undefined,
        ...params,
      }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.next_cursor ?? undefined,
  });
}
